/**
 * Feature Flags Utility
 * Provides easy access to feature flags exposed by PHP
 */
declare global {
    interface Window {
        FeatureFlags?: Record<string, boolean>;
        FeatureFlagsUtil: {
            isEnabled: (flagKey: string) => boolean;
            getAll: () => Record<string, boolean>;
        };
    }
}

(function () {
    'use strict';

    window.FeatureFlagsUtil = {
        /**
         * Check if a feature flag is enabled
         * @param flagKey - The feature flag key
         * @returns True if flag is enabled, false otherwise
         */
        isEnabled: function (flagKey: string): boolean {
            return !!(window.FeatureFlags && window.FeatureFlags[flagKey]);
        },

        /**
         * Get all feature flags
         * @returns Object containing all feature flags
         */
        getAll: function (): Record<string, boolean> {
            return window.FeatureFlags || {};
        },
    };
})();

export {};
